import { httpApi } from '@app/api/http.api'

export interface Part {
  id: string
  name: string
  description?: string
  category: string
  manufacturer?: string
  partNumber?: string
  expectedLifespan?: number
  unit: string
  price?: number
  currency: string
  alarmThreshold: number
  usageDirection: string
  deleted: boolean
  createdAt: string
  updatedAt: string
}

export interface CreatePartRequest {
  name: string
  description?: string
  category: string
  manufacturer?: string
  partNumber?: string
  expectedLifespan?: number
  unit?: string
  price?: number
  currency?: string
  alarmThreshold?: number
  usageDirection?: string
  deleted?: boolean
}

export interface UpdatePartRequest extends Partial<CreatePartRequest> {}

export interface PartsResponse {
  data: Part[]
  pagination: {
    page: number
    limit: number
    total: number
    pages: number
  }
}

export interface PartsFilters {
  page?: number
  limit?: number
  search?: string
  category?: string
  active?: boolean
}

const PARTS_ENDPOINT = 'parts'

// Parts API
export const getAllParts = (filters: PartsFilters = {}): Promise<PartsResponse> => {
  const params = new URLSearchParams()
  if (filters.page) params.append('page', filters.page.toString())
  if (filters.limit) params.append('limit', filters.limit.toString())
  if (filters.search) params.append('search', filters.search)
  if (filters.category) params.append('category', filters.category)
  if (filters.active !== undefined) params.append('active', filters.active.toString())

  return httpApi.get<PartsResponse>(`${PARTS_ENDPOINT}?${params.toString()}`).then(({ data }) => data)
}

export const getPartById = (id: string): Promise<Part> =>
  httpApi.get<Part>(`${PARTS_ENDPOINT}/${id}`).then(({ data }) => data)

export const createPart = (partData: CreatePartRequest): Promise<Part> =>
  httpApi.post<Part>(PARTS_ENDPOINT, partData).then(({ data }) => data)

export const updatePart = (id: string, partData: UpdatePartRequest): Promise<Part> =>
  httpApi.patch<Part>(`${PARTS_ENDPOINT}/${id}`, partData).then(({ data }) => data)

export const deletePart = (id: string): Promise<void> => httpApi.delete(`${PARTS_ENDPOINT}/${id}`).then(() => undefined)

export const getPartCategories = (): Promise<string[]> =>
  httpApi.get<string[]>(`${PARTS_ENDPOINT}/categories/list`).then(({ data }) => data)

// Grouped Parts API
export const partsApi = {
  getAllParts,
  getPartById,
  createPart,
  updatePart,
  deletePart,
  getPartCategories,
}
